module.exports = __webpack_public_path__ + "img/kitchen_thumb.d3610107.jpg";